import { enums, ReactSDKClient } from '@optimizely/react-sdk';
import { ActivateListenerPayload } from '@optimizely/optimizely-sdk';

export const trackContentSquare = (decisionObject: ActivateListenerPayload) => {
    let disableCallback = false;

    function callback() {
        if (!disableCallback) {
            disableCallback = true;
            if (window.CS_CONF) {
                window.CS_CONF.integrations = window.CS_CONF.integrations || [];
                window.CS_CONF.integrations.push('Optimizely Full Stack');
            }
        }
    }

    window._uxa = window._uxa || [];
    window._uxa.push(['afterPageView', callback]);

    const csPrefix = 'AB_OP_';
    const csKey = csPrefix + decisionObject.experiment.key;
    const csValue = decisionObject.variation.key;

    window._uxa.push(['trackDynamicVariable', { key: csKey, value: csValue }]);
};

export const addNotificationForContentSquare = (optimizely: ReactSDKClient) => {
    optimizely.notificationCenter.addNotificationListener(
        enums.NOTIFICATION_TYPES.ACTIVATE,
        trackContentSquare
    );
};
